import clsx from "clsx";
import styles from "./tags.module.css";

const Tags = ({ activeTag }: { activeTag?: string | null }) => {
  if (!activeTag) return null;

  return (
    <div className={styles["product-card__tags"]} product-card-tags={"true"}>
      <div
        className={clsx(
          styles["product-card__tag"],
          styles[`product-card__tag__${activeTag}`]
        )}
      >
        <p>{activeTag}</p>
      </div>
    </div>
  );
};

export default Tags;
